import React, { FC } from 'react';
import { DamageDataGrid } from './components/DamageDataGrid';
import { InspectionPageTab } from '../types';

export const Damage: FC<InspectionPageTab> = ({
  inspection,
  dataSource,
  onReload,
  canEditDamage,
  canEditFr,
  canEditParts,
  canApproveDamage,
  canChangePartComponent,
  canChangeDamageType,
  canChangeSeverity,
  canChangeRepairMethod,
  canChangeWorkCenter,
  canRemoveDamageLine,
  active,
  onGradePreviewChange,
}) => (
  <DamageDataGrid
    inspection={inspection}
    dataSource={dataSource || []}
    canEditDamage={canEditDamage}
    canEditFr={canEditFr}
    canEditParts={canEditParts}
    canApproveDamage={canApproveDamage}
    canChangePartComponent={canChangePartComponent}
    canChangeDamageType={canChangeDamageType}
    canChangeSeverity={canChangeSeverity}
    canChangeRepairMethod={canChangeRepairMethod}
    canChangeWorkCenter={canChangeWorkCenter}
    canRemoveDamageLine={canRemoveDamageLine}
    active={active}
    onReload={() => onReload?.()}
    onGradePreviewChange={onGradePreviewChange}
  />
);
